import {
  createAsyncAction,
  createAsyncTypes,
} from 'lib/reduxUtils';

// Async
export const ANONYMIZE_USER_COURSE_DATA = createAsyncTypes('userDataAnonymization/anonymizeUserCourseData');
export const anonymizeUserCourseData = createAsyncAction(ANONYMIZE_USER_COURSE_DATA);
